<div class="modal-overlay" *ngIf="isOpen" (click)="onClose()">
  <div class="modal-dialog modal-lg modal-dialog-centered" (click)="$event.stopPropagation()">
    <div class="modal-content shadow-lg">

      <div class="modal-header bg-light">
        <h5 class="modal-title">
          <i class="bi bi-tag me-2"></i>Pesquisar NCM
        </h5>
        <button type="button" class="btn-close" (click)="onClose()" aria-label="Close"></button>
      </div>

      <div class="modal-body">
        <div class="input-group mb-4">
          <span class="input-group-text bg-white"><i class="bi bi-search"></i></span>
          <input type="text" class="form-control"
                 placeholder="Digite o código ou descrição para pesquisar..."
                 [(ngModel)]="termo"
                 (keyup.enter)="search()">
          <button class="btn btn-primary px-4" type="button" (click)="search()">Pesquisar</button>
        </div>

        <div class="table-responsive" style="max-height: 450px; overflow-y: auto;">
          <table class="table table-hover align-middle">
            <thead class="table-light sticky-top">
              <tr>
                <th class="text-center" style="width: 40px;">#</th>
                <th style="width: 150px;">Código</th>
                <th>Descrição</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let ncm of ncmPage?.content"
                  (click)="selectNcm(ncm)"
                  [class.table-primary]="selectedNcm.id === ncm.id"
                  style="cursor: pointer;">
                <td class="text-center">
                  <div class="form-check d-flex justify-content-center">
                    <input class="form-check-input" type="radio" name="ncm"
                           [checked]="selectedNcm.id === ncm.id">
                  </div>
                </td>
                <td class="fw-bold">{{ ncm.codigo }}</td>
                <td>{{ ncm.descricao }}</td>
              </tr>
              <tr *ngIf="ncmPage?.content?.length === 0">
                <td colspan="3" class="text-center py-5 text-muted">
                  <i class="bi bi-info-circle me-2"></i>Nenhum NCM encontrado para "{{ termo }}".
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="d-flex justify-content-between align-items-center mt-3"
             *ngIf="ncmPage && ncmPage.totalPages > 1">
          <span class="small text-muted">
            Página {{ page + 1 }} de {{ ncmPage.totalPages }}
          </span>
          <nav aria-label="Navegação">
            <ul class="pagination pagination-sm mb-0">
              <li class="page-item" [class.disabled]="page === 0">
                <button class="page-link" (click)="setPage(0)">Primeira</button>
              </li>
              <li class="page-item" [class.disabled]="page === 0">
                <button class="page-link" (click)="setPage(page - 1)">Anterior</button>
              </li>
              <li class="page-item" [class.disabled]="page >= ncmPage.totalPages - 1">
                <button class="page-link" (click)="setPage(page + 1)">Próxima</button>
              </li>
              <li class="page-item" [class.disabled]="page >= ncmPage.totalPages - 1">
                <button class="page-link" (click)="setPage(ncmPage.totalPages - 1)">Última</button>
              </li>
            </ul>
          </nav>
        </div>
      </div>

      <div class="modal-footer bg-light">
        <button type="button" class="btn btn-outline-secondary" (click)="onClose()">Cancelar</button>
        <button class="btn btn-success px-4" type="button"
                [disabled]="!selectedNcm || selectedNcm.id === 0"
                (click)="inserirNcm()">
          <i class="bi bi-check2-circle me-2"></i>Inserir NCM
        </button>
      </div>

    </div>
  </div>
</div>
